import { render, staticRenderFns } from "./TenantList.vue?vue&type=template&id=534bd96e&scoped=true"
import script from "./TenantList.vue?vue&type=script&lang=js"
export * from "./TenantList.vue?vue&type=script&lang=js"
import style0 from "./TenantList.vue?vue&type=style&index=0&id=534bd96e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534bd96e",
  null
  
)

export default component.exports